export default "__VITE_ASSET__DZDXCpnR__"